let data = [
    {
        id: 1,
        img_url: "https://onemg.gumlet.io/diagnostics/b1f8f81e-5677-11ec-9fd9-0a65f29f7340.png?format=auto",
        rating: 4.9,
        namelab: "ISO",
        title: "TATA 1mg Labs (TATA 1mg Technologies Private  Limited )"
    },
    {
        id: 2,
        img_url: "https://onemg.gumlet.io/diagnostics/mlkrsnvxj3yqtbzxo4wj_new.png?format=auto",
        rating: 4.8,
        namelab: "CAP,ISO",
        title: "Dr. Lal PathLabs Ltd."
    },
    {
        id: 3,
        img_url: "https://onemg.gumlet.io/lab-new-image/thyrocare.png?format=auto",
        rating: 4.2,
        namelab: "ISO",
        title: "Thyrocare Technologies Limited"
    },
    {
        id: 4,
        img_url: "https://onemg.gumlet.io/diagnostics/Metropolis-logo_new.png?format=auto",
        rating: 4.7,
        namelab: "CAP",
        title: "Metropolis Laboratories"
    },
    {
        id: 5,
        img_url: "https://onemg.gumlet.io/diagnostics/caacfcae-319a-11ec-8ea4-02f26b65c396.png?format=auto",
        rating: 4.9,
        namelab: "NABH,ISO",
        title: "Dr Dangs Lab LLP"
    },
    {
        id: 6,
        img_url: "https://onemg.gumlet.io/diagnostics/c55eb562-2b2d-11ec-ba73-024de974b6dc.png?format=auto",
        rating: 4.9,
        namelab: "",
        title: "TATA 1mglabs for Covid RT-PCR"
    }
];

export default data;